// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__rBOvx","label":"LabeledBox_label__2LAjn"};